<template>
  <v-snackbar
    top
    v-model="snackbarVisible"
    :color="notification.color"
    :multi-line="!!notification.detail"
    :timeout="timeout"
    style="z-index: 1000"
    >
    <div class="mr1">
      {{notification.text}}
      <small v-if="!!notification.detail">
        <br v-if="$mq.md_sm">
        {{ notification.detail }}
      </small>
      <small v-if="!!notification.link">
        <br v-if="$mq.md_sm">
        <v-btn text dark class="m0" @click="handleNotificationLinkClick">
          {{ notification.link[0] }}
        </v-btn>
      </small>
    </div>

    <v-spacer />
    <!-- Hide this until undo functionality is implemented -->
    <!-- <v&#45;btn v&#45;if="notification.undoable" flat dark class="m0" @click="handleActionClick"> -->
    <!--   Undo -->
    <!-- </v&#45;btn> -->
    <v-btn v-if="notification.showReloadButton" text dark class="m0" @click="handleActionClick">
      Reload
    </v-btn>
    <v-btn text @click="snackbarVisible = false" dark class="m0">
      Dismiss
    </v-btn>
  </v-snackbar>
</template>


<script>
/* @flow */
import { REMOVE_NOTIFICATION } from '@/store/notifications'

export default {
  name: 'NotificationSnackbar',
  data() {
    return {
      snackbarVisible: false,
    }
  },
  mounted() {
    this.snackbarVisible = this.notificationToShow
  },
  computed: {
    notification() {
      return this.$store.getters.nextNotification || {}
    },
    notificationToShow() {
      return this.$store.getters.notificationToShow
    },
    timeout() {
      if (typeof this.notification.timeout === 'number') {
        return this.notification.timeout
      } else if (this.notification.color === 'error') {
        return 12000
      } else {
        return 6000
      }
    },
  },
  methods: {
    handleActionClick() {
      if (typeof this.notification.onClick === 'function') this.notification.onClick()
      this.snackbarVisible = false
    },
    handleNotificationLinkClick() {
      this.$router.push(this.notification.link[1])
      this.snackbarVisible = false
    },
  },
  watch: {
    notificationToShow(newValue: boolean) {
      // This shows snackbar if notification count goes from 0 to 1+
      if (newValue) {
        this.snackbarVisible = true
      }
    },
    snackbarVisible(newVal: boolean) {
      if (!newVal) {
        // Snackbar just closed
        if (this.notification) {
          this.$store.dispatch(REMOVE_NOTIFICATION, {id: this.notification.id})
        }
        this.$nextTick(() => {
          // This shows next snackbar when more than one are queued
          if (this.notificationToShow) {
            this.snackbarVisible = true
          }
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/NotificationSnackbar.vue